import { AssetClassDeletedEvent, } from '../event/asset-class-deleted.event';
const assetClassDeletedProjections = {
    [AssetClassDeletedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            deleted: payload.deleted,
        };
    },
};
export default assetClassDeletedProjections;
//# sourceMappingURL=asset-class-deleted.projection.js.map